module.exports = __webpack_public_path__ + "img/ic_contents.9325149e.svg";